import { Controller } from "@hotwired/stimulus"

export default class InlineEditController extends Controller {
  static outlets = ["dependable-frame"]
  static targets = ["editWrapper", "showWrapper", "input"]
  static values = { editModeOnly: Boolean }

  submit() {
    if (this.inputTarget.reportValidity()) {
      this.inputTarget.form.requestSubmit()
    } else {
      setTimeout(() => {
        this.openEditMode()
      })
    }
  }

  submitted(event) {
    if (event.detail.success) {
      this.#reRenderDependableFrames(event)
    } else {
      setTimeout(() => {
        this.openEditMode()
      }, 100)
    }
  }

  openEditMode(focus = true) {
    if (!this.hasShowWrapperTarget) return

    this.editWrapperTarget?.classList.remove("hidden")
    this.showWrapperTarget?.classList.add("hidden")

    if (focus) {
      this.inputTarget.focus()
    }
  }

  closeEditMode() {
    if (!this.hasShowWrapperTarget) return

    this.showWrapperTarget.classList.remove("hidden")
    this.editWrapperTarget.classList.add("hidden")
  }

  editModeOnlyValueChanged(value) {
    if (value) {
      this.openEditMode(false)
    } else {
      this.closeEditMode()
    }
  }

  inputTargetFormIsSubmitting() {
    const form = this.hasInputTarget && this.inputTarget.form
    return form && form.getAttribute("aria-busy") === "true"
  }

  closeOnFocusOutside({ target }) {
    if (
      this.element.contains(target) ||
      this.editModeOnlyValue ||
      this.inputTargetFormIsSubmitting()
    ) {
      return
    }

    this.closeEditMode()
  }

  async #reRenderDependableFrames(event) {
    const responseHTML = await event.detail.fetchResponse.responseHTML
    const doc = new DOMParser().parseFromString(responseHTML, "text/html")

    this.dependableFrameOutlets.forEach((dependableFrame) => {
      dependableFrame.renderFromDocument(doc)
    })
  }
}
